import pforte_1 from './pforte_1.jpg';
import pforte_2 from './pforte_2.jpg';
import pforte_3 from './pforte_3.jpg';
import pforte_4 from './pforte_4.jpg';

export const portfolio_pforte = [
    {product_img: pforte_1},
    {product_img: pforte_2},
    {product_img: pforte_3},
    {product_img: pforte_4}
]